import { http } from '@/api/client/httpClient';
import type { InstrumentProfitabilityResultDto } from '@/api/types/riskDashboard';
import type { InstrumentProfitabilityFilterInput } from '@/api/types/instrumentProfitability';

// GetDataAsync -> GET api/app/instrument-profitability/data (query filter).
export const instrumentProfitabilityApi = {
  async getData(input: InstrumentProfitabilityFilterInput): Promise<InstrumentProfitabilityResultDto> {
    const { data } = await http.get<InstrumentProfitabilityResultDto>('/api/app/instrument-profitability/data', {
      params: input,
    });
    return data;
  },
};
